import React from "react";
import classes from "./Services.module.css";

const Chiropractic = () => {
  return (
    <div className={classes.Intro}>
      <h1 className={classes.focusLine}>
        <span>CHIROPRACTIC</span>
      </h1>
      <div className={classes.container1}>
        <p>
          A chiropractic adjustment is a therapeutic treatment where a licensed
          chiropractor uses their hands or special instruments to manipulate
          joints in your body. This treatment is also called spinal manipulation
          or joint manipulation. A chiropractic adjustment can help reduce pain,
          correct your body’s alignment and how your body functions physically.
        </p>
        <p>
          A chiropractor treats many conditions affecting the nervous system and
          musculoskeletal system. Think of a chiropractor as a doctor who cares
          for any kind of muscle, bone or joint pain or dysfunction. The most
          common reasons for a chiropractic adjustment include:
        </p>
        <ul>
          <li>Lower back pain</li>
          <li>Neck pain</li>
          <li>Muscle pain</li>
          <li>Headaches</li>
        </ul>
        <p>
          In addition, chiropractors can treat musculoskeletal pain anywhere in
          your body: in your head and jaws, shoulders, elbows and wrists, hips
          and pelvis and your knees and ankles.
          <br />
          <br />
          Chiropractors make sure not only that your joints are moving properly,
          but also that your surrounding muscles are functioning as well.
          <br />
          <br />
          After a chiropractic adjustment, you might feel mild soreness or have
          very minor aches in areas of your body that your chiropractor worked
          on. This feeling usually goes away within 24 hours and rarely affects
          people who see a chiropractor regularly.
          <br />
          <br />
          After your appointment, your chiropractor might recommend “homework”
          for you to extend your therapy after an adjustment.
          <br />
          <br />
          These recommendations might include:
        </p>
        <ul>
            <li>Exercises and stretches</li>
            <li>Proper ergonomics for improving your posture</li>
            <li>Icing/heat therapy or topical analgesics</li>
            <li>Advice on nutrition, diet, weight or general health</li>
            <li>Ways to manage stress and relax muscles</li>
            <li>Referrals to other health professionals!</li>
        </ul>
      </div>
    </div>
  );
};

export default Chiropractic;
